export default "__VITE_ASSET__CJfnrmTp__"